import type { MotorCurveCoefficients, MotorVoltageCorrections } from "./types";

// These come from static/Motor Calcs with Updated Admin 1.xlsx
export function getMotorVoltageCorrections(
  motor: MotorCurveCoefficients,
  motorLoadRatioNP: number,
  pumpHz: number,
  motorVoltage: number
): MotorVoltageCorrections {
  if (!Number.isFinite(motorVoltage) || motorVoltage === 0) {
    return {
      optimizedVolts: 0,
      optimizedVoltRatio: 0,
      ampCorrection: 1,
      powerFactorCorrection: 1,
      efficiencyCorrection: 1,
      rpmCorrection: 1,
      tempCorrection: 1
    };
  }

  const optimizedVolts =
    (motor.nameplate_voltage || 0) *
    (motor.rr_vb +
      motor.rr_v1 * motorLoadRatioNP +
      motor.rr_v2 * motorLoadRatioNP ** 2 +
      motor.rr_v3 * motorLoadRatioNP ** 3) *
    (pumpHz / 60);

  const optimizedVoltRatio = optimizedVolts / motorVoltage;

  if (!Number.isFinite(optimizedVoltRatio) || optimizedVoltRatio <= 0) {
    return {
      optimizedVolts,
      optimizedVoltRatio,
      ampCorrection: 1,
      powerFactorCorrection: 1,
      efficiencyCorrection: 1,
      rpmCorrection: 1,
      tempCorrection: 1
    };
  }

  return {
    optimizedVolts,
    optimizedVoltRatio,
    ampCorrection:
      motor.iv0 +
      motor.iv1 * optimizedVoltRatio +
      motor.iv2 * optimizedVoltRatio ** 2,
    powerFactorCorrection:
      motor.pfv0 +
      motor.pfv1 * optimizedVoltRatio +
      motor.pfv2 * optimizedVoltRatio ** 2,
    efficiencyCorrection:
      motor.effv0 +
      motor.effv1 * optimizedVoltRatio +
      motor.effv2 * optimizedVoltRatio ** 2,
    rpmCorrection:
      motor.nv0 +
      motor.nv1 * (1 / optimizedVoltRatio) +
      motor.nv2 * (1 / optimizedVoltRatio) ** 2,
    tempCorrection:
      motor.tv0 +
      motor.tv1 * optimizedVoltRatio +
      motor.tv2 * optimizedVoltRatio ** 2
  };
}
